/**
 * The preference type for a set of preferences.
 *
 * Each preference type is resolved in order of specificity,
 * with 1 being the most specific and 5 being the least specific.
 *
 * 1. `SUBSCRIPTION_SUBSCRIBER_WORKFLOW` - The subscriber's preference for a workflow scoped to a subscription.
 * 2. `SUBSCRIBER_WORKFLOW` - The subscriber's preference for a workflow.
 * 3. `SUBSCRIBER_GLOBAL` - The subscriber's global preference.
 * 4. `USER_WORKFLOW` - The user's preference for a workflow in the dashboard.
 * 5. `WORKFLOW_RESOURCE` - The Framework-defined preference for a workflow.
 */
export var PreferencesTypeEnum;
(function (PreferencesTypeEnum) {
    PreferencesTypeEnum["SUBSCRIPTION_SUBSCRIBER_WORKFLOW"] = "SUBSCRIPTION_SUBSCRIBER_WORKFLOW";
    PreferencesTypeEnum["SUBSCRIBER_WORKFLOW"] = "SUBSCRIBER_WORKFLOW";
    PreferencesTypeEnum["SUBSCRIBER_GLOBAL"] = "SUBSCRIBER_GLOBAL";
    PreferencesTypeEnum["USER_WORKFLOW"] = "USER_WORKFLOW";
    PreferencesTypeEnum["WORKFLOW_RESOURCE"] = "WORKFLOW_RESOURCE";
})(PreferencesTypeEnum || (PreferencesTypeEnum = {}));
//# sourceMappingURL=workflow-channel-preferences.js.map